import { render, staticRenderFns } from "./Version.vue?vue&type=template&id=31590b54&scoped=true"
import script from "./Version.vue?vue&type=script&lang=js"
export * from "./Version.vue?vue&type=script&lang=js"
import style0 from "./Version.vue?vue&type=style&index=0&id=31590b54&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31590b54",
  null
  
)

export default component.exports